import { BaseEntity } from 'entities';
import { Instrument } from 'entities/instrument';
import { LaboratoryAuthority } from 'entities/laboratory_authority';
import { Room } from 'entities/room';
import { SubscriptionPlan } from 'entities/subscription_plan';
import { User } from 'entities/user';

/**
 * ラボ
 */
export type Laboratory = BaseEntity & {
  name?: string;
  branch?: string;
  zip?: string;
  address?: string;
  building?: string;
  publisher?: string;
  /** 購買管理を使用できるどうか */
  usePurchase?: boolean;
  /** 在庫管理を使用できるどうか */
  useStock?: boolean;
  /** 機器管理を使用できるどうか */
  useEquipment?: boolean;

  isManager?: boolean;
  isManaged?: boolean;

  users?: User[];

  sharedInstruments?: Instrument[];
  sharedRooms?: Room[];
  authority?: LaboratoryAuthority;
  subscriptionPlan?: SubscriptionPlan;
  instrumentTotalCount?: number;
  hasDealerUsers?: boolean;
};

// TODO: 編集フォームを実装する際は entities/instrument.ts のコメントと実装を参考に、同様の構造で実装する

// QRコード関連ページにアクセスできるラボかどうか
// laboratory や権限情報が未ロードの間は誤って許可しない
// 管理ラボでないかつ被管理ラボの場合はアクセス不可
export const canAccessQrCodePage = (laboratory?: Laboratory): boolean => {
  if (!laboratory || typeof laboratory.isManaged !== 'boolean' || typeof laboratory.isManager !== 'boolean') {
    return false;
  }

  return !(laboratory.isManaged && !laboratory.isManager);
};
